// extracted by mini-css-extract-plugin
module.exports = {"openBtn":"openBtn___f9Vjm","icon":"icon___3-jZe","fullOpenBtn":"fullOpenBtn___1y-AT"};